
const state = {
    textStauts: false,
    allData: {
        type: "text",
        label: "艺术字",
        data: [],
        type: "art",
    },
}
const getters = {
    textStauts: state => state.textStauts,
    allData: state => state.allData,
}

const mutations = {
    setTextStauts(state, data) {
        state.textStauts = data.state
    },
    setAllData(state, data) {
        state.allData = data
    },
}
export default {
    namespaced: true,
    state,
    getters,
    mutations
};




// WEBPACK FOOTER //
// ./src/store/modules/resourcesArea/textContent.js